import React, { useEffect, useState, useMemo } from "react";
import "./SubjectWise.scss";

// const subjectWiseAnalysis = [
//   {
//     subject: "Physics",
//     subject_icon:
//       "https://learning.motion.ac.in/motioneducation/public/storage/sub/Physics1.png",
//     performance_metrics: {
//       accuracy: 14.29,
//       time_spent: 54,
//       marks_obtained: -5,
//       max_marks: 100,
//       percentage: -5,
//       percentile: 3.13,
//       tpq_avg: 3.86,
//     },
//     question_breakdown: {
//       total_questions: 25,
//       attempted: 14,
//       skipped: 11,
//       correct: 2,
//       wrong: 12,
//     },
//   },

//   {
//     subject: "Biology",
//     subject_icon:
//       "https://learning.motion.ac.in/motioneducation/public/storage/sub/Physics1.png",
//     performance_metrics: {
//       accuracy: 14.29,
//       time_spent: 54,
//       marks_obtained: -5,
//       max_marks: 100,
//       percentage: -5,
//       percentile: 3.13,
//       tpq_avg: 3.86,
//     },
//     question_breakdown: {
//       total_questions: 25,
//       attempted: 14,
//       skipped: 11,
//       correct: 2,
//       wrong: 12,
//     },
//   },
// ];

const SubjectWise = ({ subjectWiseAnalysis }) => {
  const [currentSub, setCurrentSub] = useState(
    subjectWiseAnalysis?.[0]?.subject
  );

  if (!Array.isArray(subjectWiseAnalysis) || subjectWiseAnalysis.length === 0) {
    return null;
  }

  const handleOnChange = (e) => {
    setCurrentSub(e.target.value);
  };

  const filteredData = subjectWiseAnalysis?.filter((elem) => {
    return elem.subject === currentSub;
  });
  const { subject, subject_icon, performance_metrics, question_breakdown } =
    filteredData?.[0] || {};

  const {
    accuracy,
    time_spent,
    marks_obtained,
    max_marks,
    percentage,
    percentile,
    tpq_avg,
  } = performance_metrics || {};
  const { total_questions, attempted, skipped, correct, wrong } =
    question_breakdown || {};
  const unattempted = Math.max(
    0,
    Number(total_questions || 0) - Number(attempted || 0)
  );

  return (
    <div className="subjectwiseWrapper">
      <div className="subjectwiseTitle">Subject-wise Analysis </div>
      <div className="subjectwise">
        <select onChange={handleOnChange} className="subjectwise__select">
          {subjectWiseAnalysis?.map((item) => (
            <option value={item.subject}>{item.subject}</option>
          ))}
        </select>

        <div className="subjectDetails">
          <div className="subjectDetails__header">
            <div className="subjectDetails__header__subject">
              {" "}
              <img src={subject_icon} alt="icon" /> {subject}
            </div>
            <div className="subjectDetails__header__details">
              <div className="subjectDetails__header__details__marks">
                {marks_obtained}/{max_marks}
              </div>
              <div className="subjectDetails__header__details__percentage">
                {percentage}%
              </div>
            </div>
          </div>
          <div className="subjectDetails__body">
            <div className="subjectDetails__body__card">
              <div className="subjectDetails__body__card__title">
                Performance Metrics
              </div>
              <div className="subjectDetails__body__card__container">
                <div className="subjectDetails__body__card__container__item">
                  <div className="subjectDetails__body__card__container__item__value">
                    {accuracy}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Accuracy
                  </div>
                </div>
                <div className="subjectDetails__body__card__container__item">
                  <div className="subjectDetails__body__card__container__item__value">
                    {percentile}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Percentile
                  </div>
                </div>
                <div className="subjectDetails__body__card__container__item">
                  <div className="subjectDetails__body__card__container__item__value">
                    {time_spent}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Duration
                  </div>
                </div>
                <div className="subjectDetails__body__card__container__item">
                  <div className="subjectDetails__body__card__container__item__value">
                    {tpq_avg}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    TPQ (Avg)
                  </div>
                </div>
              </div>
            </div>

            <div className="subjectDetails__body__card">
              <div className="subjectDetails__body__card__title">
                Question Breakdown
              </div>
              <div className="subjectDetails__body__card__container">
                <div className="subjectDetails__body__card__container__item attemp">
                  <div className="subjectDetails__body__card__container__item__value">
                    {attempted}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Attempted
                  </div>
                </div>
                <div className="subjectDetails__body__card__container__item ski">
                  <div className="subjectDetails__body__card__container__item__value">
                    {unattempted}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Unattempted
                  </div>
                </div>
                <div className="subjectDetails__body__card__container__item corr">
                  <div className="subjectDetails__body__card__container__item__value">
                    {correct}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Correct
                  </div>
                </div>
                <div className="subjectDetails__body__card__container__item wron">
                  <div className="subjectDetails__body__card__container__item__value">
                    {wrong}
                  </div>
                  <div className="subjectDetails__body__card__container__item__title">
                    Wrong
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubjectWise;
